import { Box, Image, Stack, Text } from "@chakra-ui/react";

export default function AdjacentPlacesOfAttraction() {
  return (
    <div
      style={{
        lineHeight: "2",
        padding: "20px",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    >
      {/* Tournament Logo Section */}
      <div style={{ marginBottom: "30px" }}>
        <h2 style={{ fontSize: "22px", marginBottom: "15px" }}>
          {" "}
          Adjacent Places of Attraction
        </h2>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>Around RAJGIR</strong>
          <br />
          The ancient city, Rajagriha, now Rajgir lies at 15 km from Nalanda. It
          has been mentioned in the Hindu epic Ramayan that it was named
          Vasumati by King Vasu. 'The house of kings' as it was known,reached
          its zenith during the Magadhan period. Once the capital of Bimbisara,
          it was a prominent centre for Hindus, Buddhists and Jains. Also men-
          tioned in the writings of Buddhaghosha, a Buddhist scholar, it had 32
          main gates and 64 minor gates surrounded by hills . Lord Buddha and
          Lord Mahavir spent many years here. Rajgir is also fa- mous for hot
          water springs. RajgirMahotsav is an international festival organised
          by Bihar Tourism.
        </p>

        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="1">
                    <Text fontWeight="bold">
                      Rajgir Zoo Safari & Nature Safari
                    </Text>
                    <Text>
                      The biodiversity of Rajgir Zoo Safari includes carnivores,
                      quiet herbivores, avi-fauna, and a large variety of flora
                      that play a significant role in maintaining and balancing
                      the ecosystem. Find the Royal Bengal tiger, lion, leopard,
                      sloth bear, chital, sambar, spiral-horned black buck,
                      hog-deer, barking deer, colourful butterflies, etc. One
                      would be amazed to see umpteen varieties of plants. Nature
                      Safari is present at Rajgir-Jetian valley; one can marvel
                      at the picturesque scenery of verdant greenery. While
                      one's sojourn here; one can witness the natural beauty of
                      rocky hills, immaculate valleys, and a breathtaking
                      landscape.
                    </Text>
                  </Box>
                  <Image
                    src="https://biharsports.org/img/rajgirSSS.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%", height: "10rem" }} // Adjusts size based on screen
                  />
                </Stack>
              </li>

              <li style={{ listStyle: "auto" }}>
                <strong>Vishwa Shanti Stupa</strong>
                <br />
                The white marble stupa was built in 1969 on Ratna- giri Hill.
                Four golden statues of the Buddha adorn its dome. It rises 129
                ft and can be reached by a stairway/ropeway.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong> Gridhakuta Hill-Top</strong>
                <br />
                The quintessential meditation seat of Lord Buddha is set on the
                top of Gridhakuta Hill. Many sermons were preached by him to his
                disciples here. The red brick spot is rectangular in shape,
                confined within 2 ft high walls on three sides. Make offerings
                of prayers and coloured flags. An- cient writings of ZuanZang
                tell that its paths and stairway were constructed by King
                Bimbisara.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Pandu Pokhar</strong>
                <br />
                Visit the leisure attraction to marvel at the replicas of the
                Buddha, take a walk in the rose garden and fun garden; relish
                different traditional treats in the restaurants or go shopping
                handicrafts.
              </li>
            </ol>
          </div>
        </div>
      </div>

      {/* Mascot Section */}
      <div style={{ lineHeight: "2", marginTop: "30px" }}>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>Around NALANDA</strong>
          <br />
        </p>
        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">
                      Ruins of Vikramshila University
                    </Text>
                    <Text>
                      The university thrived between the 9th-13th century CE.
                      Founded by the Pala King Dharmapala, it was a bustling
                      education centre. Subjects taught included Philosophy,
                      Theology, Metaphysics, Grammar, Logic, Tantrism, etc. A
                      colossal square remnant of the double-storied stupa with a
                      cruciform structure, a library and votive stupas have been
                      unearthed as are a Tibetan and a Hindu temple.
                    </Text>
                  </Box>
                  <Image
                    src="https://biharsports.org/img/NalandaACT.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%" }} // Adjusts size based on screen
                  />
                </Stack>
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "20px",
                    marginBottom: "20px",
                  }}
                >
                  <a
                    href="https://tourism.bihar.gov.in/en/destinations/nalanda"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      padding: "15px 30px",
                      backgroundColor: "#ff9800", // Button background color (orange)
                      color: "white", // Text color
                      textDecoration: "none", // Remove underline
                      fontWeight: "bold",
                      borderRadius: "50px", // Rounded button
                      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)", // Shadow effect
                      transition:
                        "transform 0.3s ease, background-color 0.3s ease", // Smooth transition
                      fontSize: "16px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#e65100"; // Darker orange on hover
                      e.target.style.transform = "scale(1.1)"; // Slightly enlarge the button
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#ff9800"; // Reset background color
                      e.target.style.transform = "scale(1)"; // Reset scaling
                    }}
                  >
                    Explore Nalanda
                  </a>

                  {/* <p style={{ marginTop: "10px", color: "#555", fontSize: "14px" }}>
              Know more by visiting this link
            </p> */}
                </div>
              </li>

              <li style={{ listStyle: "auto" }}>
                <strong>Nalanda University Ruins</strong>
                <br />
                Remains of the eminent Nalanda University of the 5th century CE
                are one of the most popular destinations. It accommodated about
                2000 teachers and 10,000 students of Buddhism. Scholars
                streamedin from far and wide. It shone as an admiration for
                quality in education, architecture and as a reveredseat of
                Buddhism. Originally the area covered by the university was
                quite large as has been mentioned in the writings of famous 7th
                century CE Chinese traveler Xuanzang, also known as Hiuen Tsang.
                It reached the zenith of perfection in education and
                architecture during the periods of Guptas and Palas. Built in
                red brick, it exhibits ruins of stupas, viharas, etc.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Digambar Jain Temple, Kundalpur</strong>
                <br />
                Digambar Jain Temple, Kundalpur is a beautiful struc- ture
                constructed in white marble. As believed by the Digambar sect of
                Jains, it is the birthplace of Lord Mahavir, the 24th
                Tirthankar. Two buildings beside the main complex incorporate 72
                images of the Jinas.
              </li>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">Jal mandir, Pawapuri</Text>
                    <Text>
                      The revered religious destination for Jains is where Lord
                      Mahavir attained Nirvana. Jal Mandir, the temple in the
                      middle of the vast lotus tank was built at this site where
                      he was cremated. It is situ- ated at a distance of about
                      35 km from Rajgir.
                    </Text>
                  </Box>
                  <Image
                    src="https://biharsports.org/img/Nalanda4.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%" }} // Adjusts size based on screen
                  />
                </Stack>
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Archaeological Museum</strong>
                <br />
                It has a collection of statues of Lord Buddha, sculp- tures
                carved on basalt stones, bronze, etc. from Buddhist and Hindu
                times. Exhibits include terra- cotta items, iron implements,
                stuccos, inscriptions on stones and copper, coins and potteries,
                stupas on leaf of pipal tree, charred rice samples, etc.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Giriyak Hill Stupa</strong>
                <br />
                Situated on the top of Giriyak Hill, the 21 ft highcylindrical
                stupa was built out of red brick with a diameter of 28 ft. A
                stone path, 20 ft wide leadsto the stupa. Marvel at the
                spectacular sight of the green valley with the serene
                Ghorakatora Lake.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Ghora Katora</strong>
                <br />
                Lying near Rajgir, Ghora Katora means 'Horse Bowl'; it is a
                natural lake. It's outline looks like a horse and is encompassed
                by hills on three sides. Migratory birds from Siberia and
                central Asia reach here during winters. Marvel at the seventy ft
                tall Buddha statue that stands in the centre of the lake.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>The Xuanzang Memorial</strong>
                <br />
                The memorial was built (1984) as a mark of respectto the Chinese
                scholar and traveller, Xuanzang; hetravelled to India in the 7th
                century CE and stayedfor about five years, learning and
                translating theteachings of Buddhism into Chinese. Behold
                theremarkable statue of ZuanZang, the stone structure with the
                feet impression of Lord Buddha, worshipped by him; painting of
                Sheelbhadra, his guru;colourful paintings on the walls and
                ceilings, etc.
              </li>
            </ol>
          </div>
        </div>
      </div>

      <div style={{ lineHeight: "2", marginTop: "30px" }}>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>Around GAYA</strong>
          <br />
        </p>
        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">Mahabodhi Temple, Bodhgaya</Text>
                    <Text>
                      The 170 ft. tall temple lies as a slender Pyramidtill its
                      neck, which is cylindrical in shape. The top has chatras
                      which signify sovereignty of religion.The architecture is
                      a blend of different cultures. It certainly has an
                      influence of the Gupta era andexhibits inscriptions
                      describing visits of pilgrims from Sri Lanka, Myanmar and
                      China between 7thand 10th century CE. Marvel at the huge
                      image of the Buddha in sitting post ure touching the
                      earthby his right hand (bhoomisparsh); in this posture,
                      Buddha attained enlightenment.
                    </Text>
                  </Box>
                  <Image
                    src="https://biharsports.org/img/gayaturist.jpg"
                    alt="Description of the image"
                    objectFit="cover"
                    boxSize={{ base: "100%", lg: "50%" }} // Adjusts size based on screen
                  />
                </Stack>
              </li>

              <li style={{ listStyle: "auto" }}>
                <strong>Mahabodhi Tree</strong>
                <br />
                The Buddha attained supreme knowledge and enlightenment sitting
                onVajrasana, the seat of stability, a stone platform under the
                Bodhi Tree.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>80 ft Buddha Statue</strong>
                <br />
                The first gigantic Buddha statue built in modernIndia, famous as
                the 80 ft Buddha Statue was com- missioned and consecrated in
                1989; the ceremonywas attended by His Holiness the Dalai Lama.
                It issituated next to the Mahabohdi Temple.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>AnimeshLochan Stupa</strong>
                <br />
                It is believed that the Buddha continued to gaze at the great
                Bodhi tree, absorbed in divine content- ment, for one week,
                without blinking his eyes after attaining enlightenment.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Chankramana Asthal</strong>
                <br />
                After attaining enlightenment, Buddha walked around the sacred
                place; his footprints are figured in black stone as also are 19
                lotus carvings.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Ratnaghar</strong>
                <br />
                After the enlightenment, Buddha meditated; a holy light in five
                different colours came out from his persona. As a tribute of
                that divine event a stat- ue in meditating posture was sculpted.
                These five colours are present in the Buddhist flag.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Shree Mahabodhi Mahavihar</strong>
                <br />
                Laying before the access to Mahabodhi Temple, it was built by
                the Mahabodhi Society of India in 2007; ancient relic coffers of
                Sariputra and Maham- alyayan, Buddha's two pupils are secured
                here.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Dungeshwari Hill Cave</strong>
                <br />
                Gautama is believed to have meditated here for a long period
                before moving to Bodhgaya. A gold- en bony Buddha statue is
                enshrined in one of the cave temples; in the other, a tall
                Buddha's statue is placed. A Hindu goddess Dungeshwari is also
                en- shrined inside the cave temple. A concreted walk- way leads
                to the temples. There are many Buddha image carvings.
              </li>
              <li style={{ listStyle: "auto" }}>
                <strong>Vishnupad Temple</strong>
                <br />
                In 1787, Devi Ahilya Bai Holkar got the present structure of the
                Vishnu Temple constructed on the bank of River Phalgu. It has a
                beautiful architec- ture and attracts devotees in large numbers.
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div style={{ lineHeight: "2", marginTop: "30px" }}>
        <p style={{ textAlign: "justify", marginBottom: "15px" }}>
          <strong>Around NAWADA</strong>
          <br />
        </p>
        {/* <h5 style={{ textAlign: "justify", marginBottom: "15px" }}>Key Components of the Logo:</h5> */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "30px",
          }}
        >
          <div style={{ flex: "12" }}>
            <ol style={{ paddingLeft: "20px", textAlign: "justify" }}>
              <li style={{ listStyle: "auto" }}>
                <Stack direction={{ base: "column", lg: "row" }} spacing={4}>
                  <Box flex="2">
                    <Text fontWeight="bold">Kakolat Waterfalls</Text>
                    <Text>
                      The fall is a major point of attraction for tourists and
                      visitors. Lying about 33 km from Nawada, it is more than
                      150 ft high.
                    </Text>
                  </Box>
                </Stack>
              </li>
            </ol>
          </div>
        </div>
        <p>
          <strong>
            To explore Bihar Tourism, visit on the official website of Bihar
            Tourism at{" "}
            <a
              href="https://tourism.bihar.gov.in/en"
              target="_blank"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              https://tourism.bihar.gov.in/en{" "}
            </a>
          </strong>
        </p>
      </div>
    </div>
  );
}
